import axiosInstance from '../../../../common/axios.service';
import type {ADD_GROUP_PAYLOAD, ADD_USER, UPDATE_GROUP_PAYLOAD} from './roles.type';
import type FILTERS from '../../../../common/filters.type';

const roles = () => {
  return axiosInstance.get('permission/group').then((response) => {
    return response;
  });
};
const addRole = (payload: ADD_GROUP_PAYLOAD) => {
  return axiosInstance.post('permission/group', payload).then((response) => {
    return response;
  });
};
const updateRole = (values: {groupId: number; payload: UPDATE_GROUP_PAYLOAD}) => {
  return axiosInstance
    .put(`permission/group/${values.groupId}`, values.payload)
    .then((response) => {
      return response;
    });
};
const roleEmployees = (values: {groupId: number; filters: FILTERS}) => {
  return axiosInstance
    .get(`permission/employee-group/${values.groupId}`, {params: values.filters})
    .then((response) => {
      return response;
    });
};
const addInRole = (values: ADD_USER) => {
  return axiosInstance.post(`permission/employee-group`, values).then((response) => {
    return response;
  });
};
const removeFromRole = (relationId: number) => {
  return axiosInstance.delete(`permission/employee-group/${relationId}`).then((response) => {
    return response;
  });
};
const totalPermissions = () => {
  return axiosInstance.get('permission').then((response) => {
    return response;
  });
};
const roleServices = {
  roles,
  addRole,
  updateRole,
  roleEmployees,
  addInRole,
  removeFromRole,
  totalPermissions,
};

export default roleServices;
